import { useRouter } from "vue-router";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useNavigationStore } from "@/stores/navigationStore";

export type RouteName = (typeof ROUTE_NAMES)[keyof typeof ROUTE_NAMES];

export function useSafeBack() {
  const router = useRouter();
  const navStore = useNavigationStore();

  function safeBack(fallbackRouteName: RouteName) {
    if (navStore.previousRoute) {
      router.back();
    } else {
      router.push({ name: fallbackRouteName });
    }
  }

  return { safeBack };
}
